<template>
    <v-dialog
        v-model="emailData.dialog"
        :max-width="options.width"
        persistent
        v-bind:style="{ zIndex: options.zIndex }"
        >
        <v-card>
            <v-card-title class="title blue-title pa-3 pt-4 ml-2">
                Change E-mail
                <div class="header-close" title="close" @click="emailData.dialog = false"><v-icon>close</v-icon></div>
            </v-card-title>

            <v-card-text>
                <v-form v-model="emailValid" ref="emailForm" class="px-2">
                    <v-layout row wrap>
                        <v-flex xs12>
                            <v-flex xs12>
                                <v-subheader class="pa-0 form-title">Email</v-subheader>
                            </v-flex>
                            <v-text-field v-model="newEmail"
                                        :rules="[rules.required, rules.emailRules]"
                                        required
                                        outline
                                        single-line
                                        ></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-form>
                <v-form v-model="codeValid" ref="codeForm" class="px-2">
                     <v-layout row wrap>
                        <v-flex xs8>
                            <v-flex xs12>
                                <v-subheader class="pa-0 form-title">Vertification Code</v-subheader>
                            </v-flex>
                            <v-text-field 
                                    v-model="verificationCode"
                                    :rules="[rules.required]"
                                    single-line 
                                    outline 
                                    class="body-2"></v-text-field>
                        </v-flex>
                        <v-flex xs4 pl-3>
                            <v-btn class="text-none white--text blue-button upload-btn" @click="sendCode" :disabled="!canGet">
                                    {{getCodeBtn}}</v-btn>
                        </v-flex>
                    </v-layout>
                    <p class="change-email-box-tips">* No verification code has been received or the original email is not available. Please contact your administrator</p>
                </v-form>
                
            </v-card-text>

            <v-layout row>
                <v-flex xs12 class="text-xs-center py-3">
                  <v-btn
                        class="text-none red-button dialog-submit"
                        @click="changeEmail"
                        >Submit</v-btn>
                </v-flex>
            </v-layout>
      </v-card>
    </v-dialog>
</template>
<script>
import { SendChangeEmailVerificationEmail , ChangeTutorPrivateEmail } from '@/api/user'
import store from '@/store'
import { mapGetters } from 'vuex'
export default {
    name: 'changeEmail',
    props: {
        emailData: {
            dialog: false
        }
    },
    computed: {
    ...mapGetters([
      'user'
    ])
  },
    data: ()=>({
        emailValid: false,
        codeValid: false,
        newEmail:'',
        verificationCode:'',
        rules: {
            required: value => !!value || 'Required.',
            emailRules: v => /.+@.+/.test(v) || 'E-mail must be valid'
        },
        canGet: true,
        timer: null,
        count: 60,
        getCodeBtn: "Send",
        options:{
            width: 550,
            zIndex: 200
        }
    }),
    methods:{
        async sendCode(){
            this.verificationCode = ''
            this.$refs.codeForm.resetValidation()
            if (!this.$refs.emailForm.validate()) {
                return
            }
            if(this.newEmail === this.user.email) {
                this.$root.$alertTips('The new email is same with the old one.', '',{ icon: { default:true } });
                return
            }
            if (!this.timer) {
                const TIME_COUNT = 60;
                this.count = TIME_COUNT;
                this.canGet = false;
                this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                        this.count--;
                        this.getCodeBtn = '('+this.count+")s";
                    } else {
                        this.canGet = true;
                        clearInterval(this.timer);
                        this.timer = null;
                        this.getCodeBtn = 'reSend'
                    }
                }, 1000)
            }
            let resInfo = await SendChangeEmailVerificationEmail(this.user.email).then(res=>{
                return res
            })
            switch (resInfo.Code) {
                case 0:
                    this.$root.$alertTips('send success',"success");
                    break;
                default:
                    this.$root.$alertTips(resInfo.Msg, '',{ icon: { default:true } });
                    break;
            }


        },
        changeEmail(){
            if (!this.$refs.codeForm.validate() && !this.$refs.emailForm.validate()) {
                return
            }
            ChangeTutorPrivateEmail(this.user.email, this.verificationCode, this.newEmail).then(res=>{
                switch (res.Code) {
                    case 0:
                        this.$root.$alertTips(res.Msg, "success");
                        store.dispatch('updateEmail', this.newEmail)
                        this.emailData.dialog = false
                        if(this.$route.name == 'newPersonalData') { // 更新个人中心数据
                             setTimeout(() => {
                                 window.location.reload()
                             }, 2000);
                        }
                        break;
                    default:
                        this.$root.$alertTips(res.Msg, '', { icon: { default:true } });
                        break;
                }
            })

        }
        
    },
    watch:{
        'emailData.dialog': function (value) { 
            if(value){
                this.$refs.codeForm.resetValidation()
                this.$refs.emailForm.resetValidation()
                this.verificationCode = ''
                this.newEmail = ''
            }
            if(!value && this.timer){
                this.canGet = true;
                clearInterval(this.timer);
                this.timer = null;
                this.getCodeBtn = 'Send'
            }
        }
    }
}
</script>

<style scoped>
.change-email-box-tips{
    color: rgba(50, 57, 122, 0.4);
}
[data-theme="theme1"] .change-email-box-tips{
    color: rgba(255, 255, 255, 0.4);
}
</style>